"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.licenseTcSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const licenseTcSubMenu = exports.licenseTcSubMenu = [{
  path: '/license-tcs/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/licenseTc/list.vue'))),
  name: 'LicenseTcList',
  meta: {
    title: 'licenseTcManagement.licenseTcs.title',
    noCache: true,
    icon: 'series',
    roles: ['System Admin', 'Super Admin']
  }
}, {
  path: '/license-tcs/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/licenseTc/manage.vue'))),
  name: 'AddLicenseTc',
  props: {
    isEdit: false
  },
  meta: {
    title: 'licenseTcManagement.licenseTcs.manage',
    noCache: true,
    activeMenu: '/license-tcs/list',
    hidden: true
  }
}, {
  path: '/license-tcs/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/licenseTc/manage.vue'))),
  name: 'EditLicenseTc',
  props: {
    isEdit: true
  },
  meta: {
    title: 'licenseTcManagement.licenseTcs.manage',
    noCache: true,
    activeMenu: '/license-tcs/list',
    hidden: true
  }
}];